__turbopack_context__.v({
  "content": "styles-module-scss-module__PTn4vG__content",
  "price": "styles-module-scss-module__PTn4vG__price",
  "root": "styles-module-scss-module__PTn4vG__root",
  "title1": "styles-module-scss-module__PTn4vG__title1",
  "title2": "styles-module-scss-module__PTn4vG__title2",
  "title3": "styles-module-scss-module__PTn4vG__title3",
});
